import stockImg from 'assets/stockImg.png'

export const SecondProject = {
  id: 2,
  name: 'Stonks',
  desc: 'An application that provides instant, comprehensive stock insights, giving you real-time prices and market trends.',
  longDesc:
    `I developed this stock checker application as a way to challenge myself and see how quickly I could build a fully functional RESTful app. 
    The goal was to create a tool that allows users to easily track and monitor stock prices in real-time, all through a simple and user-friendly interface. 
    On the backend, I focused on ensuring the system was reliable and could handle multiple requests smoothly, providing accurate and up-to-date information. 
    The project not only tested my ability to manage different aspects of application development but also provided valuable insights into balancing speed with
    quality.`,
  link: 'https://github.com/Keitech/stock-check',
  img: stockImg,
  technology: ['ReactJS', 'MUI', 'Flask'],
  date: 'May 30 2024',
  year: 2024,
  online: true,
}